import { FormHandles } from '@unform/core';
import React, { useCallback, useRef } from 'react';
import * as yup from 'yup';

import { ModalHeader } from '../../../components/ModalHeader';
import { InputToken } from '../../../components/InputToken';
import { useModal } from '../../../hooks/modal';
import { useToast } from '../../../hooks/toast';
import { api } from '../../../services/api';
import { getValidationErrors } from '../../../utils/getValidationErrors';

import {
  Cancel,
  Container,
  Content,
  FooterRow,
  FormContainer,
  Info,
  Submit,
} from './styles';

interface ChangeMailProps {
  avatar_url?: string;
  fullname: string;
}

interface formProps {
  token: string;
}

const ChangeMail2: React.FC<ChangeMailProps> = () => {
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const { removeModal, removeAllModals } = useModal();

  const handleSubmit = useCallback(async (data: formProps) => {
    try {
      formRef.current?.setErrors({});

      const schema = yup.object().shape({
        token: yup.string().required('Campo obrigatório'),
      });

      await schema.validate(data, { abortEarly: false });

      const code = data.token.toUpperCase();

      await api.put(
        'users/email/',
        {},
        {
          headers: {
            code,
          },
        },
      );

      addToast({
        type: 'success',
        title: 'Email alterado com sucesso',
      });

      removeAllModals();
    } catch (err: any) {
      if (err instanceof yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);

        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: 'Um ou mais campos estão em branco.',
        });

        return;
      }

      if (err?.response?.status === 403) {
        addToast({
          type: 'error',
          title: 'Código inválido',
          description: `Por favor, insira o token recebido pelo email corretamente.`,
        });
        return;
      }

      addToast({
        type: 'error',
        title: 'Houve um erro na solicitação. Tente novamente mais tarde.',
      });
    }
  }, []);
  return (
    <Container>
      <ModalHeader title="Alterar email" />
      <Content>
        <FormContainer ref={formRef} onSubmit={handleSubmit}>
          <Info text="Agora, insira abaixo o código recebido no email para confirmação." />

          <InputToken name="token" />

          <Info text="Verifique também na caixa de spam" />

          <FooterRow>
            <Cancel type="button" onClick={() => removeModal()}>
              Voltar
            </Cancel>
            <Submit name="submit" value="Confirmar e salvar" />
          </FooterRow>
        </FormContainer>
      </Content>
    </Container>
  );
};

export { ChangeMail2 };
